import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const DaySortKey = union([
    literal("priority"),
    literal("expected_exchange_date"),
    literal("expected_completion_date"),
    literal("exchange_deadline_date"),
    literal("completion_deadline_date"),
]);
export type TDaySortKeyCodec = typeof DaySortKey;
export type TDaySortKey = TTypeOfCodec<TDaySortKeyCodec>;
